import { items } from "@api/stores/salesInvoices/returns/items/api";
import { reclaim } from "@api/stores/salesInvoices/returns/reclaim/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  ISalesInvoicesReturnsDto,
  ISalesInvoicesReturnsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISalesInvoicesReturnsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.salesInvoices.returns");
const postApis = createPostApi<
  IApiResponse<ISalesInvoicesReturnsResponse>,
  IPathBaseParam,
  ISalesInvoicesReturnsDto
>("stores.salesInvoices.returns");
const getApis = createGetApi<
  IApiResponse<ISalesInvoicesReturnsResponse>,
  IPathByIdParam,
  object
>("stores.salesInvoices.returns");

export const returns = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  items,
  reclaim,
};
